import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import SharedProviders_0_0 from './extensions/f842d93dd5d072a049c4d164a22f0bd11f932b4faa4abd6add6ff869b764a0c6/providers';
import SharedProviders_1_0 from './extensions/3d04dc66fd079daa078a61b6a622163602f672b5cb2d130ff62f873d5ec4e46a/providers';


@NgModule({
    imports: [CommonModule, ],
    providers: [...SharedProviders_0_0, ...SharedProviders_1_0],
})
export class SharedExtensionsModule {}
